<div class="fx-row align-items-center justify-content-between">
    <div class="fx-row fx-flex-100 align-items-center justify-content-start">
        <span class="text light">{{'DOCUMENT.TRADEMARKS_DETECTED' | translate}}</span>
        <mat-icon class="main ml-5" fontSet="material-icons-outlined" inline inset
            [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'DOCUMENT.FILTERED_SECTION' | translate"
            *ngIf="hasFilters()">filter_list</mat-icon>
    </div>

    <mat-icon [class.shown]="shown" class="visibility-icon ml-10" fontSet="material-icons-outlined">{{shown ?
        'visibility' :
        'visibility_off'}}</mat-icon>
</div>
<div class="fx-column mt-8" [class.border-bottom]="index < _trademarks.slice(0,limit).length -1"
    *ngFor="let trademark of _trademarks | sort:'confidence':'desc' | limit:limit; let index = index">
    <div class="fx-row fx-wrap mb-10 w-100 align-items-center justify-content-between"
        [class.clickable]="hasDetectedNiceClasses(trademark)"
        (click)="hasDetectedNiceClasses(trademark) ? trademark.expanded = !trademark.expanded : null">
        <div class="fx-row align-items-center justify-content-start">
            <mat-icon class="mr-5" [class.main]="hasDetectedNiceClasses(trademark)"
                [class.light]="!hasDetectedNiceClasses(trademark)"
                fontSet="material-icons-outlined">{{trademark.expanded ?
                'arrow_drop_down' :
                'arrow_right'}}</mat-icon>
            <div class="fx-column fx-flex ellipsis-container" *ngIf="trademark.name">
                <a (click)="toTrademark(trademark.ref)" class="fx-flex-100 ellipsis">{{trademark.name}}</a>
                <span class="small light  fx-flex-100">{{trademark.countryOfDesignation}} -
                    {{trademark.identifierNumber}}</span>
            </div>
            <div class="fx-column fx-flex ellipsis-container" *ngIf="!trademark.name">
                <a (click)="toTrademark(trademark.ref)" class="fx-flex-100 ellipsis">{{trademark.identifierNumber}}</a>
                <span class="small light  fx-flex-100">{{trademark.countryOfDesignation}}</span>
            </div>
            <div class="chip main outline ml-8" *ngIf="trademark.classes && hasDetectedNiceClasses(trademark)">
                {{trademark.classes.length}} {{((trademark.classes.length > 1 ? 'ENTITIES.NICE_CLASSES' :
                'ENTITIES.NICE_CLASS') | translate).toLowerCase()}}
            </div>
            <div class="chip light outline ml-8" *ngIf="!hasDetectedNiceClasses(trademark)">
                {{'DOCUMENT.NO_NICE_CLASS_DETECTED' | translate}}
            </div>
        </div>
        <app-metadata-confidence *ngIf="trademark" class="ml-20"
            [value]="trademark.confidence || 0"></app-metadata-confidence>
    </div>
    <div *ngIf="trademark.expanded">
        <div class="fx-column" *ngFor="let niceClass of trademark.classes | sort:'confidence':'desc'">
            <div class="fx-row fx-wrap mb-10 ml-10 fx-flex-100 align-items-center justify-content-between"
                [class.clickable]="hasDetectedPS(niceClass)"
                (click)="hasDetectedPS(niceClass) ? niceClass.expanded = !niceClass.expanded : null">
                <div class="fx-row align-items-center justify-content-start">
                    <mat-icon class=" mr-5" [class.main]="hasDetectedPS(niceClass)"
                        [class.light]="!hasDetectedPS(niceClass)" fontSet="material-icons-outlined">{{niceClass.expanded
                        ?
                        'arrow_drop_down' :
                        'arrow_right'}}</mat-icon>
                    <div class="chip main" [matTooltipClass]="{'uzai-tooltip':true}"
                        [matTooltip]="'NICE_CLASSES.'+niceClass.classNumber | translate">
                        <span><b>{{'NICE_CLASSES.CLASS_NUMBER' |
                                translate}}{{niceClass.classNumber}}</b></span>
                    </div>
                    <div class="chip main outline ml-8" *ngIf="niceClass.terms && hasDetectedPS(niceClass)">
                        {{niceClass.terms.length}} {{((niceClass.terms.length > 1 ? 'ENTITIES.PRODUCTS_SERVICES' :
                        'ENTITIES.PRODUCT_SERVICE') | translate).toLowerCase()}}
                    </div>
                    <div class="chip light outline ml-8" *ngIf="!hasDetectedPS(niceClass)">
                        {{'DOCUMENT.NO_PS_DETECTED' | translate}}
                    </div>
                </div>

                <app-metadata-confidence class="ml-20" [value]="niceClass.confidence || 0"></app-metadata-confidence>
            </div>
            <div *ngIf="niceClass.expanded && trademark.expanded">
                <div class="fx-column" *ngFor="let term of niceClass.terms | sort:'confidence':'desc'">
                    <div class="fx-row mb-10 ml-40 fx-flex-100 align-items-center justify-content-between">
                        <span class="text dark">{{term.label}}</span>
                        <app-metadata-confidence class="ml-20" [value]="term.confidence || 0"></app-metadata-confidence>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<span class="text" *ngIf="!trademarks || trademarks.length === 0">-</span>
<div class="fx-row w-100 align-items-center justify-content-end mt-10 clickable" *ngIf="trademarks.length > 3">
    <span class="text main" (click)="toggle()">{{(limit === 3 ? 'UTILS.SEE_MORE' : 'UTILS.SEE_LESS') |
        translate}}</span>
    <mat-icon class="main ml-5" fontSet="material-icons-outlined">{{limit === 3 ? 'keyboard_arrow_down' :
        'keyboard_arrow_up'}}</mat-icon>
</div>